export default __webpack_public_path__ + "static/media/hht1_storybook_20.94efa553.png";